export default __webpack_public_path__ + "static/CareerFeatureTwo-c01f47b8b55a2aeedac96ed23603190f.webp";